import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconVMark } from '../../../../../assets/icons/svg/shared/ic-shared-checkmark-circle.svg';

export const InvoiceMarkAsPaidSuccess = () => {
  const { t } = useTranslation();
  return (
    <div className='text-bw00 text-lg font-metricR items-center justify-between flex h-[60px] py-[8px] px-[16px]'>
      <IconVMark className='stroke-bw00 w-[32px] h-[22px]' />
      <div className='ml-[9px] flex flex-wrap items-center'>
        <div className='font-metricRMedium text-md text-bw00'>
          {t('INVOICE_HUB_MODALS.MARK_AS_PAID.TOAST_SUCCESS.TITLE')}
        </div>
        <div className='font-metricR text-sm text-bw00'>{t('INVOICE_HUB_MODALS.MARK_AS_PAID.TOAST_SUCCESS.TEXT')}</div>
      </div>
    </div>
  );
};
